import AppState from 'models/AppState';
import User from 'models/User';

export const selectAuthUser = (state: AppState): User => state.auth.authUser;

export const selectAlertMessage = (state: AppState): string => state.auth.alertMessage;

export const selectIsMessageVisible = (state: AppState): boolean => state.auth.isMessageVisible;
